/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useGetTitleCss } from './titleStyle';
export var DomH1 = function (props) {
    var _a = props.styleAs, styleAs = _a === void 0 ? 'h1' : _a, display = props.display, alignItems = props.alignItems, justifyContent = props.justifyContent, lines = props.lines, minLines = props.minLines, color = props.color, backgroundColor = props.backgroundColor, textAlign = props.textAlign, textTransform = props.textTransform, letterSpacing = props.letterSpacing, fontSize = props.fontSize, fontWeight = props.fontWeight, lineFactor = props.lineFactor, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, flex = props.flex, flexBasis = props.flexBasis, flexGrow = props.flexGrow, flexShrink = props.flexShrink, alignSelf = props.alignSelf, borderStyle = props.borderStyle, borderHorizontalStyle = props.borderHorizontalStyle, borderVerticalStyle = props.borderVerticalStyle, borderTopStyle = props.borderTopStyle, borderLeftStyle = props.borderLeftStyle, borderBottomStyle = props.borderBottomStyle, borderRightStyle = props.borderRightStyle, borderWidth = props.borderWidth, borderHorizontalWidth = props.borderHorizontalWidth, borderVerticalWidth = props.borderVerticalWidth, borderTopWidth = props.borderTopWidth, borderLeftWidth = props.borderLeftWidth, borderBottomWidth = props.borderBottomWidth, borderRightWidth = props.borderRightWidth, borderColor = props.borderColor, borderHorizontalColor = props.borderHorizontalColor, borderVerticalColor = props.borderVerticalColor, borderTopColor = props.borderTopColor, borderLeftColor = props.borderLeftColor, borderBottomColor = props.borderBottomColor, borderRightColor = props.borderRightColor, parentBorderTopStyle = props.parentBorderTopStyle, parentBorderLeftStyle = props.parentBorderLeftStyle, parentBorderBottomStyle = props.parentBorderBottomStyle, parentBorderRightStyle = props.parentBorderRightStyle, parentBorderTopColor = props.parentBorderTopColor, parentBorderLeftColor = props.parentBorderLeftColor, parentBorderBottomColor = props.parentBorderBottomColor, parentBorderRightColor = props.parentBorderRightColor, parentBorderTopWidth = props.parentBorderTopWidth, parentBorderLeftWidth = props.parentBorderLeftWidth, parentBorderBottomWidth = props.parentBorderBottomWidth, parentBorderRightWidth = props.parentBorderRightWidth, borderRadius = props.borderRadius, borderLeftBeforeTopRadius = props.borderLeftBeforeTopRadius, borderRightBeforeTopRadius = props.borderRightBeforeTopRadius, borderLeftBeforeBottomRadius = props.borderLeftBeforeBottomRadius, borderRightBeforeBottomRadius = props.borderRightBeforeBottomRadius, borderTopRadius = props.borderTopRadius, borderRightRadius = props.borderRightRadius, borderBottomRadius = props.borderBottomRadius, borderLeftRadius = props.borderLeftRadius, borderTopLeftRadius = props.borderTopLeftRadius, borderTopRightRadius = props.borderTopRightRadius, borderBottomRightRadius = props.borderBottomRightRadius, borderBottomLeftRadius = props.borderBottomLeftRadius, borderSpacing = props.borderSpacing, borderCollapse = props.borderCollapse, position = props.position, top = props.top, right = props.right, bottom = props.bottom, left = props.left, widthLines = props.widthLines, onClick = props.onClick, children = props.children;
    var css = useGetTitleCss({
        styleAs: styleAs,
        display: display,
        alignItems: alignItems,
        justifyContent: justifyContent,
        lines: lines,
        minLines: minLines,
        color: color,
        backgroundColor: backgroundColor,
        textAlign: textAlign,
        textTransform: textTransform,
        letterSpacing: letterSpacing,
        fontSize: fontSize,
        fontWeight: fontWeight,
        lineFactor: lineFactor,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        flex: flex,
        flexBasis: flexBasis,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        alignSelf: alignSelf,
        borderStyle: borderStyle,
        borderHorizontalStyle: borderHorizontalStyle,
        borderVerticalStyle: borderVerticalStyle,
        borderTopStyle: borderTopStyle,
        borderLeftStyle: borderLeftStyle,
        borderBottomStyle: borderBottomStyle,
        borderRightStyle: borderRightStyle,
        borderWidth: borderWidth,
        borderHorizontalWidth: borderHorizontalWidth,
        borderVerticalWidth: borderVerticalWidth,
        borderTopWidth: borderTopWidth,
        borderLeftWidth: borderLeftWidth,
        borderBottomWidth: borderBottomWidth,
        borderRightWidth: borderRightWidth,
        borderColor: borderColor,
        borderHorizontalColor: borderHorizontalColor,
        borderVerticalColor: borderVerticalColor,
        borderTopColor: borderTopColor,
        borderLeftColor: borderLeftColor,
        borderBottomColor: borderBottomColor,
        borderRightColor: borderRightColor,
        parentBorderTopStyle: parentBorderTopStyle,
        parentBorderLeftStyle: parentBorderLeftStyle,
        parentBorderBottomStyle: parentBorderBottomStyle,
        parentBorderRightStyle: parentBorderRightStyle,
        parentBorderTopColor: parentBorderTopColor,
        parentBorderLeftColor: parentBorderLeftColor,
        parentBorderBottomColor: parentBorderBottomColor,
        parentBorderRightColor: parentBorderRightColor,
        parentBorderTopWidth: parentBorderTopWidth,
        parentBorderLeftWidth: parentBorderLeftWidth,
        parentBorderBottomWidth: parentBorderBottomWidth,
        parentBorderRightWidth: parentBorderRightWidth,
        borderRadius: borderRadius,
        borderLeftBeforeTopRadius: borderLeftBeforeTopRadius,
        borderRightBeforeTopRadius: borderRightBeforeTopRadius,
        borderLeftBeforeBottomRadius: borderLeftBeforeBottomRadius,
        borderRightBeforeBottomRadius: borderRightBeforeBottomRadius,
        borderTopRadius: borderTopRadius,
        borderRightRadius: borderRightRadius,
        borderBottomRadius: borderBottomRadius,
        borderLeftRadius: borderLeftRadius,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomRightRadius: borderBottomRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderSpacing: borderSpacing,
        borderCollapse: borderCollapse,
        position: position,
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        widthLines: widthLines,
    });
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    jsx("h1", { css: ouiStyle.mediaQuery(css), onClick: onClick }, children));
};
DomH1.displayName = 'DomH1';
